$(function(){
	// 都道府県選択イベント
	$('#post_pref').on('change', function(){
		$('#address_search').hide();
		$('#address_list').hide();
		$('#address_list').empty();
		getPopCityList($('#post_pref').val());
	});
	// 市区町村選択イベント
	$('#post_city').on('change', function(){
		getPopSearchList($('#post_city').val());
	});
	
	// 動的に生成するボタンイベント
	// かな文字検索
	$(document).on('click', '.js_add_search', function(){
		searchArray = $(this).attr('rel').split('|');
		kanaData = searchArray[0].split(':');
		cityData = searchArray[1].split(':');
		getPopAddressList(kanaData[1], cityData[1]);
	});
	// かな選択へ戻る
	$(document).on('click', '#js_add_search_back', function(){
		$('#address_list').hide();
		$('#address_list').empty();
		$('#address_search').fadeIn();
	});
	
	// 郵便番号、住所をセット
	$(document).on('click', '.add_select', function(){
		zipCd = $(this).attr('rel');
		$('#postal').val(zipCd);
		$('#postal').removeClass('inq-form-errbg');
		getAddressForPostal(zipCd);
		$('#ipop_close').click();
	});
	
	// ipop用の市区町村リスト更新
	if ($('#post_pref') != '') {
		getPopCityList($('#post_pref').val());
	}
});



// 市区町村リスト取得
function getPopCityList($prefCd) {
	// 都道府県、市区町村が選択されていない場合はなにもしない
	if ($prefCd == undefined) {
		return;
	}
	// 読み込み中
	$('#post_city').children().before('<option class="js-select-dummy" selected></option>');
	$('.js-select-dummy').parent().addClass('js-select-loading');

	//ajaxで市区町村リスト取得
	$.ajax({
		type: "POST",
		url: "/city/get_combo_list_by_pref/" + $prefCd,
		data: { is_json: 1}
	}).done(function( res ) {
		// 読み込み中削除
		$('.js-select-dummy').remove();
		$('#post_city').removeClass('js-select-loading');
		
		// 市区町村リストをリセット
		$('#post_city').html('<option value="">市区町村を選択してください</option>');
		
		// 市区町村リスト成形
		for (var i in res.list) {
			$('#post_city').append($('<option label="' + res.list[i].City.s_place_name + '" value="' + res.list[i].City.s_place_cd +'">' + res.list[i].City.s_place_name + '</option>'));
		}
	});

}

function getPopSearchList($cityCd) {
	if ($cityCd == undefined) { return; }
	// 読み込み中
	$('#post_city').after('<div class="js-address-list-loading"></div>');
	//ajaxで町名・番地取得
	$.ajax({
		type: "POST",
		url: "/kana/get_kana_list_by_city/" + $cityCd,
		data: { is_json: 1}
	}).done(function( res ) {
		$('.js-address-list-loading').remove();
		$('#address_search').fadeIn();
		if ($('#address_list').children().is(':visible')) {
			$('#address_list').hide();
			$('#address_list').empty();
		}
		
		for (var i in res.list) {
			for (var k in res.list[i]) {
				// リストを初期化
				$('#td_'+res.list[i][k].romaji).html('');
				$('#td_'+res.list[i][k].romaji).html(res.list[i][k].hiragana);
				// 市区町村リストの更新
				for (var obj in res.list[i][k].list) {
					// IE8対応 Object.keys()をjQueryで代替しています
					var objKeys = $.map(res.list[i][k].list[obj], function(value, key) {
					    return key;
					});
					// 市区町村が存在するキーをリンクにする
					if (res.list[i][k].list[obj] != '' && objKeys.length > 0) {
						$('#td_'+res.list[i][k].romaji).html('<a href="javascript:void(0)" class="js_add_search" rel="kana:' + res.list[i][k].katakana + '|s_place_cd:' + res.list[i][k].list[obj].s_place_cd +'">' + res.list[i][k].hiragana + '</a>');
					}
				}
			}
		}
	});
}

function getPopAddressList($kana, $cityCd) {
	if ($kana == undefined || $kana == undefined) {return;}
	$kana = encodeURI($kana);
	$.ajax({
		type: 'POST',
		url: '/postal/get_address_list_by_kana/' + $cityCd + '/' + $kana,
		scriptCharset: 'UTF-8',
		dataType: 'json',
		data: { is_json: 1 }
	}).done(function( res ) {
		$('#address_search').hide();
		$('#address_list').empty();
		$('#address_list').show();
		$('#address_list').append('<tr><td class="add_cond_td" colspan="2">' + res.list[0].Postal.pref_name + res.list[0].Postal.s_place_name + 'の"' + res.list.searchWord +'"で始まる地域</td></tr>');
		for (var i in res.list) {
			if (res.list[i].Postal) {
				if (res.list[i].Postal.address2 == '') {
					$('#address_list').append('<tr><th class="add_list_th">' + res.list[i].Postal.zip_cd + ' 上記以外の地域' + '</th><td class="add_list_td"><a href="javascript:void(0)" class="add_select" rel="' + res.list[i].Postal.zip_cd + '">この郵便番号を設定する</a></td></tr>')
				} else {
					$('#address_list').append('<tr><th class="add_list_th">' + res.list[i].Postal.zip_cd + ' ' + res.list[i].Postal.address2 + '</th><td class="add_list_td"><a href="javascript:void(0)" class="add_select" rel="' + res.list[i].Postal.zip_cd + '">この郵便番号を設定する</a></td></tr>')
				}
			}
		}
		$('#address_list').append('<tr><td><a href="javascript:void(0);" id="js_add_search_back" class="add_search_back">かな 選択へ戻る</a></td></tr>');
	});
}